// extracted by mini-css-extract-plugin
export default {"button":"fmh-arrow-button_button__n+bBY","disabled":"fmh-arrow-button_disabled__7pWXy"};